import {
  faCirclePlus,
  faFileImport,
  faFileLines,
  faLandmark,
  faListCheck,
  faTableList
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Flex } from 'components';
import { Button } from 'components/_form';
import { useState } from 'react';
import { theme } from 'styles';
import { CreateAssessmentModal } from '../AssessmentActionsModal/CreateAssessmentModal';
import { useTranslation } from 'react-i18next';
import { Tooltip } from 'react-tooltip';
import { useAssessmentContext } from 'contexts/AssessmentContext';

export const ActionsMenu = () => {
  const [isOpenModal, setIsOpenModal] = useState(false);

  const { setIsCreateAuditModalOpen } = useAssessmentContext();

  const { t } = useTranslation();

  return (
    <>
      <Flex gap="5px" justifyContent="space-between">
        <Button
          variant="greyWhite"
          bordered
          icon={
            <Flex
              alignItems="end"
              id="new-assessment"
              data-tooltip-content={
                t('assessmentsView.actionsMenu.newAssessment') as string
              }
            >
              <FontAwesomeIcon
                icon={faLandmark}
                size="xl"
                color={theme.palette.accent.green}
              />
              <FontAwesomeIcon
                icon={faCirclePlus}
                size="xs"
                color={theme.palette.accent.green}
              />
              <Tooltip anchorId="new-assessment" />
            </Flex>
          }
          onClick={() => {
            setIsOpenModal(true);
          }}
        />
        <Button
          variant="greyWhite"
          bordered
          onClick={() => {
            setIsCreateAuditModalOpen(true);
          }}
          icon={
            <Flex
              alignItems="end"
              id="new-audit"
              data-tooltip-content={
                t('assessmentsView.actionsMenu.newAudit') as string
              }
            >
              <FontAwesomeIcon
                icon={faListCheck}
                size="xl"
                color={theme.palette.accent.blue}
              />
              <FontAwesomeIcon
                icon={faCirclePlus}
                size="xs"
                color={theme.palette.accent.blue}
              />
              <Tooltip style={{ zIndex: 9 }} anchorId="new-audit" />
            </Flex>
          }
        />
        <Button
          variant="greyWhite"
          bordered
          icon={
            <Flex
              alignItems="end"
              id="new-form"
              data-tooltip-content={
                t('assessmentsView.actionsMenu.newForm') as string
              }
            >
              <FontAwesomeIcon
                icon={faTableList}
                size="xl"
                color={theme.palette.accent.red}
              />
              <FontAwesomeIcon
                icon={faCirclePlus}
                size="xs"
                color={theme.palette.accent.red}
              />
              <Tooltip style={{ zIndex: 9 }} anchorId="new-form" />
            </Flex>
          }
        />
        <Button
          variant="greyWhite"
          bordered
          icon={
            <Flex
              alignItems="end"
              id="new-derivative"
              data-tooltip-content={
                t('assessmentsView.actionsMenu.newDerivative') as string
              }
            >
              <FontAwesomeIcon
                icon={faFileLines}
                size="xl"
                color={theme.palette.accent.brown}
              />
              <FontAwesomeIcon
                icon={faCirclePlus}
                size="xs"
                color={theme.palette.accent.red}
              />
              <Tooltip style={{ zIndex: 9 }} anchorId="new-derivative" />
            </Flex>
          }
        />
        <Button
          variant="greyWhite"
          bordered
          icon={
            <Flex
              alignItems="end"
              id="import-assessment"
              data-tooltip-content={
                t('assessmentsView.actionsMenu.importAssessment') as string
              }
            >
              <FontAwesomeIcon
                icon={faFileImport}
                size="xl"
                color={theme.palette.accent.steelBlue}
              />
              <Tooltip style={{ zIndex: 9 }} anchorId={'import-assessment'} />
            </Flex>
          }
        />
      </Flex>

      <CreateAssessmentModal
        isOpen={isOpenModal}
        onCancelClick={() => setIsOpenModal(false)}
      />
    </>
  );
};
